import { IMaintenanceReadingValueModel } from "./maintenance-reading-value.model";

export interface IMaintenanceReadingModel {
	maintenanceReadingId: number;
	customerId: number;
	appointmentId?: number;
	// The pool/spa this was recorded on. Null on records that predate the Assets tab.
	structureId?: number;
	maintenanceReadingDate: Date;
	maintenanceReadingValues: IMaintenanceReadingValueModel[];
}

export class MaintenanceReadingModel implements IMaintenanceReadingModel {
	constructor() {
		this.maintenanceReadingId = 0;
		this.maintenanceReadingValues = []
    }
	maintenanceReadingId: number;
	customerId: number;
	appointmentId?: number;
	// The pool/spa this was recorded on. Null on records that predate the Assets tab.
	structureId?: number;
	maintenanceReadingDate: Date;
	maintenanceReadingValues: IMaintenanceReadingValueModel[];
}